export const de = {
  translation: {
    general: {
      now: 'Jetzt',
    },
    navLeft: {
      home: 'Home',
      news: 'News',
      projects: 'Projekte',
      gallery: 'Galerie',
      aboutme: 'Über mich',
      contact: 'Kontakt',
      impressum: 'Impressum',
      readme: 'README'
    },
    tapbar: {
      closeAll: 'Alle schließen'
    },
    home: {
      title: 'DWAIN',
      subTitle: 'professionell // effizient // sicher',
      counter: {
        experience: {
          count: '15+',
          title: 'Jahre IT Erfahrung'
        },
        codeExperience: {
          count: '6000+',
          title: 'Stunden Programmiererfahrung'
        },
        projects: {
          count: '10+',
          title: 'Erfolgreiche Projekte'
        }
      }
    },
    contact: {
      title: 'In',
      title1: 'Kontakt',
      title2: 'kommen!',
      subtitle: 'Ich freue mich darauf, mit dir ein Projekt zu starten oder dir bei deinem Probleme helfen zu können',
      form: {
        inputNameplaceholder: 'Geb dein Namen ein',
        inputMailplaceholder: 'Geb deine Email ein',
        inputTextplaceholder: 'Geben deine Nachricht ein',
        enterButton: 'Senden',
        sending: 'Wird gesendet...',
        errorName: 'Bitte gib deinen Namen ein',
        errorMail: 'Bitte gib eine gültige E-Mail-Adresse ein',
        errorText: 'Bitte gib eine Nachricht ein',
        successMessage: 'Nachricht erfolgreich gesendet! Ich melde mich bald bei dir.',
        errorMessage: 'Beim Senden ist ein Fehler aufgetreten. Bitte versuche es erneut.'
      }
    },
    me: {
      infoText1: 'Ich bin ein Computer-Nerd, seit ich 14 bin. Alles fing ganz oldschool an: Den eigenen PC zusammenbauen, die erste HTML-Seite basteln – seitdem lässt mich die IT nicht mehr los.',
      infoText2: 'Egal ob IT-Security oder fiese Bugs im Code - mich reizt es einfach, Probleme zu lösen. Ich bin jemand, der sich solange mit Komplikationen auseinandersetzt, bis sie aus dem Weg geräumt sind. Mittlerweile bin ich auch großer Bitcoin-Fan, weil die Technik und das Konzept dahinter die Zukunft von Vertrauen ist.',
      infoText3: 'Aber ich lebe nicht nur digital, ich bin auch leidenschaftlicher Hardware-Schrauber. PCs selbst zu planen und zusammenzubauen gehört für mich einfach dazu. Das geht inzwischen so weit, dass ich fehlende Teile oder Halterungen selbst konstruiere und im 3D-Drucker realisiere.',
      infoText4: 'Wenn dann noch Zeit bleibt, beschäftige ich mich mit 3D-Design oder zocke eine Runde, um den Kopf freizukriegen. Diese Mischung aus technischem Tüfteln, Hardware-Bau und Kreativität ist genau mein Ding – und der Grund, warum mir mein Job als Softwareentwickler jeden Tag Spaß macht.',
      infoText5: '',
      card: {
        '2026': {
          position: 'Founder & Developer',
          text: 'Erste Android App — Full-Stack App zur Dokumentation und Verwaltung von Pflanzenzuchten'
        },
        '2018': {
          position: 'Developer',
          text: 'Entwicklung & Planung diverser Tools'
        },
        '2016': {
          position: 'Founder',
          text: 'Newsseite rund um Sandbox Spiele'
        },
        '2013': {
          position: 'Founder',
          text: 'Community Fanpage über das MMORPG Blackdesert'
        },
        '2011': {
          position: 'Founder',
          text: 'Community Fanpage über das MMORPG ArcheAge'
        }
      }
    },
    error: {
      title: 'SEITE NICHT GEFUNDEN'
    },
    gallery: {
      title: 'Galerie',
      timespan: '2004 - Heute',
      subtitle: 'Diverse Bilder und Videos meiner arbeiten',
      empty: 'Noch keine Einträge vorhanden. Füge Bilder oder Videos hinzu, um deine Galerie zu füllen.'
    },
    projects: {
      title: 'Projekte',
      subtitle: 'Eine Übersicht meiner Projekte und Arbeiten',
      soccerwatch: {
        description: 'Entwicklung und Planung einer umfassenden Streaming-Plattform für Fußball mit Live-Übertragungen, Video-on-Demand und Community-Features.'
      },
      staige: {
        description: 'Moderne E-Sport Streaming-Plattform mit Echtzeit-Chat, Turnierverwaltung und Analysefunktionen für professionelle Gamer.'
      },
      sandboxer: {
        description: 'News-Portal rund um Sandbox-Spiele mit aktuellen Artikeln, Reviews und Community-Diskussionen. Die größte Sandbox-Datenbank mit umfassenden Informationen über Sandbox-Spiele.'
      },
      blackdesert: {
        description: 'Community-Fanseite zum MMORPG Black Desert Online mit Guides, News und aktiver Community.'
      },
      archeage: {
        description: 'Die größte deutsche Fanpage für ArcheAge mit über 14 Millionen Unique Klicks. In Hochzeiten bis zu 10.000 gleichzeitige User online. Umfassendes Community-Forum, Guides, Datenbanken und aktuelle News-Berichterstattung.'
      },
      mygrowbook: {
        description: 'Meine erste Android App — Full-Stack App zur Dokumentation und Verwaltung von Pflanzenzuchten mit Tagebuch, Kostentracking, Equipment-Verwaltung und Community-Features.'
      }
    },
    impressum: {
      title: 'Impressum',
      contact: {
        title: 'Kontakt'
      },
      disclaimer: {
        title: 'Haftungsausschluss',
        content: 'Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann ich jedoch keine Gewähr übernehmen. Als Diensteanbieter bin ich gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.'
      },
      copyright: {
        title: 'Urheberrecht',
        content: 'Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.'
      }
    },
    'Welcome to React': 'Willkommen to React and react-i18next'
  }
}